import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../../interfaces/IReduxState";

export const TutorDashboardStatusReadSlice = createSlice({
  name: "TutorDashboardStatusReadSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    TutorDashboardStatusRead: (state) => {
      state.isLoading = true;
    },
    successTutorDashboardStatusRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureTutorDashboardStatusRead: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearTutorDashboardStatusRead: (state) => {
      state.data = {};
    },
  },
});

export const {
  TutorDashboardStatusRead,
  successTutorDashboardStatusRead,
  failureTutorDashboardStatusRead,
  clearTutorDashboardStatusRead,
} = TutorDashboardStatusReadSlice.actions;

export default TutorDashboardStatusReadSlice.reducer;
